import React from "react";
import ReactApexChart from "react-apexcharts";
import { Card, CardBody } from "reactstrap";

const GRAPH_COLORS = {
  teal: "#06402b",
  axisText: "#adb5bd",
  gridBorder: "#f6f6f6",
};

const CHART_OPTIONS = {
  chart: {
    type: "bar",
    toolbar: { show: false },
  },
  plotOptions: {
    bar: {
      distributed: false,
      borderRadius: 4,
      columnWidth: "30%",
    },
  },
  colors: [GRAPH_COLORS.teal],
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: [],
    labels: {
      style: {
        fontSize: "13px",
        fontFamily: "Poppins",
        fontWeight: 500,
      },
    },
    axisBorder: { show: false },
    axisTicks: { show: false },
  },
  yaxis: {
    min: 0,
    max: 100,
    title: {
      text: "Percentage of Retained Users",
      rotate: -90,
      style: {
        color: GRAPH_COLORS.axisText,
        fontSize: "12px",
        fontFamily: "Poppins",
        fontWeight: 700,
      },
    },
    labels: {
      formatter: (val) => Math.round(val),
    },
  },
  legend: { show: false },
  grid: {
    borderColor: GRAPH_COLORS.gridBorder,
  },
  tooltip: {
    y: {
      formatter: (val) => `${val}%`,
    },
  },
};

const RetentionGraph = ({ data = {} }) => {
  const retentionData = data?.retention || {};
  const categories = Object.keys(retentionData).map((k) =>
    k.replace("_", " ").replace(/\b\w/g, (c) => c.toUpperCase())
  );
  const values = Object.values(retentionData);
  const hasRetentionData = values.length > 0;
  const chartValues = hasRetentionData ? values : [0, 0, 0, 0, 0];
  const chartCategories = hasRetentionData
    ? categories
    : ["Week 0", "Week 1", "Week 2", "Week 3", "Week 4"];
  const maxValue = Math.max(...chartValues, 100);

  const chartOptions = {
    ...CHART_OPTIONS,
    xaxis: {
      ...CHART_OPTIONS.xaxis,
      categories: chartCategories,
    },
    yaxis: {
      ...CHART_OPTIONS.yaxis,
      max: maxValue,
    },
  };

  return (
    <Card className="mt-4">
      <CardBody>
        <h5 className="mb-3 font-family-lexend standard-typo-14-500-ld">
          User Retention by Week
        </h5>
        <ReactApexChart
          type="bar"
          series={[{ name: "Retained Users", data: chartValues }]}
          options={chartOptions}
          height={320}
        />
      </CardBody>
    </Card>
  );
};

export default RetentionGraph;
